import React, { useCallback } from 'react'
import { useUpdateLog } from 'utils/log'

import CheckLine, { CheckLineProps } from '../items/CheckLine'
import { FormTitleProps } from '../items/FormTitle'
import BaseGroup from './BaseGroup'

/**
 * 対象がCheckGroupProps型かチェックする
 * @param target チェック対象
 */
export const isCheckGroupProps = (target: any): target is CheckGroupProps => {
  return target.checks !== undefined && target.title !== undefined
}

/**
 * チェックグループ
 */
const CheckGroup: React.FC<CheckGroupProps> = (props) => {
  const toggleCheck = useCallback(
    (index: number): void => {
      const state = [...props.checks]
      if (props.isExclusion) {
        state
          .filter((check, checkIndex) => checkIndex !== index)
          .forEach((check) => (check.isChecked = false))
      }
      state[index].isChecked = !state[index].isChecked
      props.setChecks && props.setChecks(state)
    },
    [props]
  )

  useUpdateLog(
    props.title,
    {
      title: props.title,
      isRequired: props.isRequired,
      isExclusion: props.isExclusion,
      checks: props.checks,
    },
    [props]
  )

  return (
    <BaseGroup
      isRequired={props.isRequired}
      title={props.title}
      description={props.description}
      hideTitle={props.hideTitle}
    >
      {props.checks.map((check, index) => (
        <CheckLine
          {...check}
          key={index}
          onClick={(): void => {
            toggleCheck(index)
          }}
        />
      ))}
    </BaseGroup>
  )
}

export type CheckGroupProps = FormTitleProps & {
  checks: Array<CheckLineProps>
  formName: string
  isExclusion?: boolean
  setChecks?: (checks: Array<CheckLineProps>) => void
}

export default React.memo<CheckGroupProps>(CheckGroup)
